import React, { Component } from 'react'
import {
    Paper,
    Typography,
    Link,
    Button,
} from '@material-ui/core';
import * as consts from 'shared/consts.js';

const classes = {
    card: {
        width: '840px',
        padding: '4rem 4rem 4rem',
    },
    cardNoPadding: {
        width: '840px',
        overflow: 'auto',
    },
    boldText: {
        fontWeight: '500',
    },
    marginBottom: {
        marginBottom: '1rem',
    },
    marginBottomBig: {
        marginBottom: '2.2rem'
    },
}

const getNavItems = () => {
    return ['About', 'Data Glossary', 'Contact', 'Terms & Conditions']
}

const Page = (props) => {
    const { title, children } = props;

    return (
        <Paper elevation={1} style={classes.card}>
            <Typography style={{ textAlign: 'center', marginTop: '.8rem', marginBottom: '.8rem' }} variant="h5">
                {title}
            </Typography>
            <div style={{ padding: '1.8rem 1.5rem 0' }}>
                {children}
            </div>
        </Paper>
    );
};

const About = (props) => (
    <Page title="About the HouseATL Data Collective">
        <Typography style={classes.marginBottom} variant="body1">
            The HouseATL Data Collective is a coordinated and collaborative initiative to build a unified database of subsidized affordable housing in the metro Atlanta area.        
        </Typography>
        <Typography style={classes.marginBottom} variant="body1">
        The initiative is led by <Link target="_blank" rel="noopener" href="https://www.enterprisecommunity.org/about/where-we-work/southeast">Enterprise Community Partners Southeast</Link>, in partnership with the <Link target="_blank" rel="noopener" href="https://www.atlantaga.gov/">City of Atlanta</Link>, <Link target="_blank" rel="noopener" href="https://www.investatlanta.com/">Invest Atlanta</Link>, <Link target="_blank" rel="noopener" href="https://beltline.org/">Atlanta BeltLine, Inc.</Link>, <Link target="_blank" rel="noopener" href="https://www.atlantahousing.org/">Atlanta Housing</Link>, the <Link target="_blank" rel="noopener" href="https://www.dca.ga.gov/">Georgia Department of Community Affairs</Link>, and the <Link target="_blank" rel="noopener" href="https://atlantaregional.org/">Atlanta Regional Commission (ARC)</Link>.
        </Typography>
        <Typography style={classes.marginBottom} variant="body1">
          Enterprise Community Partners engaged <Link target="_blank" rel="noopener" href="https://cc.gatech.edu/">Georgia Tech’s College of Computing</Link> and <Link target="_blank" rel="noopener" href="https://cspav.gatech.edu/"> Center for Spatial Planning Analytics and Visualization (CSPAV)</Link>, as well as <Link target="_blank" rel="noopener" href="https://neighborhoodnexus.org/">Neighborhood Nexus</Link>, to develop and manage the HouseATL database and interactive website. 
        </Typography>
        <Typography style={classes.marginBottom} variant="body1">
            This project originated from the HouseATL <Link target="_blank" rel="noopener" href="http://houseatl.org/wp-content/uploads/2018/09/HOUSEATL-FINAL-RECOMMENDATIONS_9.18.18.pdf">September 2018 report</Link> of recommendations to advance affordable housing and community retention. This database and interactive website are directly related to the following recommendation: Create a database of existing affordable housing properties in the city/metro region at risk of being lost in future years.
        </Typography>
    </Page>
)

const Glossary = (props) => (
    <Paper elevation={1} style={classes.cardNoPadding}>
        <div dangerouslySetInnerHTML={{ __html: `<iframe src="${consts.embeddedDocLink}" width="840" height="780" style="border: none;"></iframe>`}} />
    </Paper>
)

const Contact = (props) => (
    <Page title="Contact">
        <Typography style={classes.marginBottom} variant="body1">
            For further information about the HouseATL Data Collective, contact Sara Haas, Director, Southeast Market at Enterprise Community Partners, Inc. via email: <Link href="mailto:shaas@enterprisecommunity.org">shaas@enterprisecommunity.org</Link>
        </Typography>
        <Typography style={classes.marginBottom} variant="body1">
            For system related questions contact Erik Woodworth, Research & Application Development Coordinator, Atlanta Regional Commission via email: <Link href="mailto:ewoodworth@atlantaregional.org">ewoodworth@atlantaregional.org</Link>
        </Typography>
    </Page>
)

const TermsConditions = () => (
  <Page title="Terms & Conditions">
      <Typography style={classes.marginBottom} variant="body1">
      The underlying data of the Atlanta Affordable Housing Database is periodically updated, with dates of updates noted in the dataset. We are not responsible for any errors in the underlying raw data. The Atlanta Affordable Housing Database is not intended as a comprehensive list of every single subsidized unit in the city of Atlanta.      
      </Typography>
  </Page>
)

class AboutComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
        }
    }

    render() {
        const { activeIndex } = this.state;

        const navItems = getNavItems();


        return (
            <div className="container">
                <div className="row">
                    <div className="col-2">
                        <div className="about-side-nav-box">
                            <div className="about-nav-items">
                                {navItems.map((item, index) => (
                                    <Button
                                        key={index}
                                        className={index === activeIndex ? 'active' : ''}
                                        onClick={() => { this.setState({ activeIndex: index }) }}
                                    >
                                        {item}
                                    </Button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="col-10">
                        <div className="body-center">
                            {activeIndex === 0 && (
                                <About />
                            )}
                            {activeIndex === 1 && (
                                <Glossary />
                            )}
                            {activeIndex === 2 && (
                                <Contact />
                            )}
                            {activeIndex === 3 && (
                                <TermsConditions />
                            )}
                            {activeIndex === 4 && (
                                <Page />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AboutComponent